import { Divider, Form, Input, Spin, Table } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { save } from "../../../../../../features/save/saveSlice";
import svg44 from "../../../../../../assets/svg/svg44.svg";
import svg45 from "../../../../../../assets/svg/svg45.svg";
import svg46 from "../../../../../../assets/svg/svg46.svg";
import svg40 from "../../../../../../assets/svg/svg40.svg";
import toast from "react-hot-toast";
import {
  fetchData,
  fetchFiles,
} from "../../../../../../features/fetch/fetchSlice";
import useModalToggle from "../../../../../../custom_hooks/useModalToggle";
import DocumentAdd from "./DocumentAdd";
import ConfirmModal from "../../../../../../components/ConfirmModal";

const { TextArea } = Input;
function Concept({ handleNext, handleBack }) {
  const { open, handleCancel, handleOpen } = useModalToggle();
  const url = "api/v2/projectFiles/get";
  const urlSingle = "api/v2/main_projects/get";
  const { saving } = useSelector((state) => state.save);
  const { loading, data, count, activeObjPlannedProject, dataProjSingle } =
    useSelector((state) => ({
      loading: state.fetch.loading,
      data: state.fetch.data[url] || [],
      count: state.fetch.count[url] || 0,
      activeObjPlannedProject: state.obj.activeObj["plannedProject"],
      dataProjSingle: state.fetch.data[urlSingle] || [],
    }));

  const { refetchKey } = useSelector((state) => state.global);
  const [form] = Form.useForm();
  const formRef = useRef(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [prodd, setProdd] = useState();

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v2/projectFiles/delete",
        pfId: prodd?.pfId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const downloadFile = async (item) => {
    try {
      const res = await dispatch(fetchFiles({ file: item }));
      if (res?.payload) {
        window.open(res.payload, "_blank");
      }
    } catch (error) {
      console.error("Failed to open file:", error);
    }
  };

  const columns = [
    {
      title: "Supporting documents",
      dataIndex: "pfFileName",
      render: (item) => {
        return (
          <div className="  flex items-center gap-x-[.65rem]">
            {" "}
            <img src={svg44} alt="svg44" />
            {item}
          </div>
        );
      },
    },

    {
      title: (
        <div
          className="p-[.5rem] w-[2rem] h-[2rem] flex items-center justify-center rounded-[0.375rem]
           border border-[#D6E1F5] bg-white cursor-pointer"
          onClick={() => handleOpen()}
        >
          <img src={svg40} alt="svg40" />
        </div>
      ),
      width: "10px",
      render: (item) => {
        return (
          <div
            className="flex items-center gap-x-[.62rem]"
            onClick={() => setProdd(item)}
          >
            <img
              src={svg45}
              alt="svg45"
              className="cursor-pointer"
              onClick={() => downloadFile(item?.pfFilePath)}
            />
            <img
              className="cursor-pointer"
              src={svg46}
              alt="svg46"
              onClick={() => handleOpenDelete()}
            />
          </div>
        );
      },
    },
  ];

  const onFinish = async (data) => {
    const res = await dispatch(
      save({
        conceptDescription: data?.conceptDescription,
        projectId: activeObjPlannedProject?.projectId,
        url: "api/v2/main_projects/save",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await handleNext();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        pfFileCategory: "CONCEPT",
        pfFileDescription: "SUPPORTING_DOCUMENT",
        pfProjectId: activeObjPlannedProject?.projectId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }
  async function fetchProjData() {
    await dispatch(
      fetchData({
        url: urlSingle,
        projectId: activeObjPlannedProject?.projectId,
        limit: null,
        start: 0,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
    fetchProjData();
  }, []);

  useEffect(() => {
    form.setFieldsValue({
      conceptDescription: dataProjSingle?.[0]?.conceptDescription,
    });
  }, [dataProjSingle]);

  return (
    <>
      <div className="flex lg:item-center lg:flex-row flex-col gap-[1.25rem]  min-h-[45vh] justify-between">
        <div className="w-full">
          <Form
            layout="vertical"
            ref={formRef}
            name="control-ref"
            onFinish={onFinish}
            className=""
            style={{
              maxWidth: "100%",
            }}
            form={form}
          >
            <Form.Item
              name="conceptDescription"
              label={"Description of the project concept"}
              rules={[
                {
                  required: true,
                  message: "Please add description of the project concept",
                },
              ]}
            >
              <TextArea
                placeholder="Description"
                rows={7}
                className="text_area"
              />
            </Form.Item>
          </Form>
        </div>
        <div className="  w-full">
          <Table
            rowSelection={false}
            className="w-full"
            scroll={{
              x: "auto",
            }}
            rowKey={(record) => record?.pfId}
            columns={columns}
            dataSource={data}
            loading={loading}
            pagination={{
              position: ["bottomRight"],
              current: pageIndex + 1,
              total: count,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchTableData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
          />
        </div>
      </div>
      <div className="sticky bottom-0 left-0 w-full">
        <Divider />
        <div className="flex justify-end mt-[1rem] gap-x-[1.25rem]">
          <div className="w-[100px]">
            <button type="button" key="back" className="cstm-btn">
              Back
            </button>
          </div>

          <div className="w-[100px]">
            <button
              onClick={() => form.submit()}
              disabled={saving}
              type="button"
              className="cstm-btn-2"
            >
              {saving ? <Spin /> : "Next"}
            </button>
          </div>
        </div>
      </div>

      <DocumentAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        prodd={prodd}
      />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content="Are you sure you want perfom this action?"
        type="alert"
        btnTitle="Delete"
      />
    </>
  );
}

export default Concept;
